/**
 * WebAuthn（パスキー）のブラウザAPIとJSON間の変換ヘルパー。
 * サーバー側(lbuchs/webauthn)は「=?BINARY?B?...?=」形式でバイナリをJSONに埋め込むため、
 * navigator.credentials.create/get に渡す前にArrayBufferへ復元する必要がある。
 */

// サーバーが返したcreateArgs/getArgs内の「=?BINARY?B?...?=」文字列をArrayBufferに復元する
export function decodeBinaryFields(obj) {
  const prefix = '=?BINARY?B?';
  const suffix = '?=';
  if (obj && typeof obj === 'object') {
    for (const key in obj) {
      const val = obj[key];
      if (typeof val === 'string' && val.startsWith(prefix) && val.endsWith(suffix)) {
        const b64 = val.substring(prefix.length, val.length - suffix.length);
        const binary = window.atob(b64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
        obj[key] = bytes.buffer;
      } else if (val && typeof val === 'object') {
        decodeBinaryFields(val);
      }
    }
  }
  return obj;
}

// ArrayBuffer → 標準base64文字列（サーバー側はbase64_decodeで受け取る）
export function bufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
  return window.btoa(binary);
}

export function isWebAuthnSupported() {
  return !!(window.PublicKeyCredential && navigator.credentials && navigator.credentials.create && navigator.credentials.get);
}
